import { SaleService } from "../api/psc";
import Callback from "../authentication/Callback";
import Impersonate from "../authentication/Impersonate";
import Login from "../authentication/Login";
import NotFoundPage from "../components/NotFoundPage";
import AdDetailPage from "../features/ads/pages/AdDetailPage";
import Chat from "../features/chat/Chat";
import CourseAttendanceHistory from "../features/courses/pages/CourseAttendanceHistory";
import CourseQRCode from "../features/courses/pages/CourseQRCode";
import ListCourses from "../features/courses/pages/ListCourses";
import ScorePage from "../features/customer-support/pages/ScorePage";
import AccountSettings from "../features/etc/pages/AccountSettings";
import Folders from "../features/folders/pages/Folders";
import Ideas from "../features/forum/pages/Ideas";
import InvalidDataReport from "../features/idr/pages/InvalidDataReport";
import AssignPassword from "../features/management/AssignPassword";
import CreateUser from "../features/management/CreateUser";
import DeleteUser from "../features/management/DeleteUser";
import ListUsers from "../features/management/ListUsers";
import Profile from "../features/management/Profile";
import UpdateUser from "../features/management/UpdateUser";
import ListPolls from "../features/polls/pages/ListPolls";
import PollDetail from "../features/polls/pages/PollDetail";
import PrintProjects from "../features/projects/pages/PrintProjects";
import ProjectMap from "../features/projects/pages/ProjectMap";
import Projects from "../features/projects/pages/Projects";
import PromotedProjects from "../features/projects/pages/PromotedProjects";
import SubmitRegistration from "../features/registration/pages";
import Report from "../features/reports/pages/Report";
import Today from "../features/sales/pages/Today";
import CreateSmsCampaign from "../features/smsCampaign/pages/CreateSmsCampaign";
import SmsCampaignList from "../features/smsCampaign/pages/SmsCampaignList";
import AccountData from "../features/store/pages/AccountData";
import PurchaseHistory from "../features/store/pages/PurchaseHistory";
import Store from "../features/store/pages/Store";
import Subscriptions from "../features/subscriptions/pages/subscriptions";
import Survey from "../features/surveys/pages/Survey";
import ListTutorials from "../features/tutorials/pages/ListTutorials";

// defines routes and menu items
export interface MenuDefinition {
    // the title used for displayed menu
    title: string;
    // url used for react-router
    url: string;
    // icon used for displayed menu
    icon?: string;
    // if the item should be displayed in menu or not, if not it will only be added as a route
    display: boolean;
    // if the scaffold should display the menu for this page
    showMenu: boolean;
    // if the user should be provided for the component
    requireAuthentication: boolean;
    // options for whether it should displaying in appbar, drawer or menu
    displayMode?: { userMenu: string[]; appBar: string[]; drawer: string[] };
    // the child routes for this item
    children?: MenuDefinition[];
    // the resolver for getting the component
    componentResolver?: JSX.Element;
    badgeCountResolver?: () => Promise<number | string>;
}

export const menuItems: MenuDefinition[] = [
    {
        title: "بانک اطلاعات ساختمان",
        url: "/",
        icon: "foundation",
        display: true,
        showMenu: true,
        requireAuthentication: true,
        displayMode: {
            userMenu: [],
            appBar: ["md", "lg", "xl"],
            drawer: ["xs", "sm"],
        },
        children: [
            {
                title: "پروژه های در حال ساخت",
                url: "/",
                icon: "business",
                display: true,
                requireAuthentication: true,
                showMenu: true,
                displayMode: {
                    userMenu: [],
                    appBar: ["md", "lg", "xl"],
                    drawer: ["xs", "sm"],
                },
                componentResolver: <Projects />,
            },
            {
                title: "پروژه ها روی نقشه",
                url: "/map",
                icon: "map",
                display: true,
                showMenu: true,
                requireAuthentication: true,
                displayMode: {
                    userMenu: [],
                    appBar: ["md", "lg", "xl"],
                    drawer: ["xs", "sm"],
                },
                componentResolver: <ProjectMap />,
            },
            {
                title: "پروژه های بازاریابی شده",
                url: "/promoted",
                icon: "stars",
                display: true,
                showMenu: true,
                requireAuthentication: true,
                displayMode: {
                    userMenu: [],
                    appBar: ["md", "lg", "xl"],
                    drawer: ["xs", "sm"],
                },
                componentResolver: <PromotedProjects />,
            },
            {
                title: "تنظیمات پروژه ها",
                url: "/settings",
                icon: "settings",
                display: true,
                showMenu: true,
                requireAuthentication: true,
                displayMode: {
                    userMenu: [],
                    appBar: ["md", "lg", "xl"],
                    drawer: ["xs", "sm"],
                },
                componentResolver: <AccountSettings />,
            },
            {
                title: "مدیریت پوشه ها",
                url: "/folders",
                icon: "folder",
                display: true,
                showMenu: true,
                requireAuthentication: true,
                displayMode: {
                    userMenu: [],
                    appBar: ["md", "lg", "xl"],
                    drawer: ["xs", "sm"],
                },
                componentResolver: <Folders />,
            },
            {
                title: "گزارشات خطا",
                url: "/invalid-data-report",
                icon: "report",
                display: true,
                showMenu: true,
                requireAuthentication: true,
                displayMode: {
                    userMenu: [],
                    appBar: ["md", "lg", "xl"],
                    drawer: ["xs", "sm"],
                },
                componentResolver: <InvalidDataReport />,
            },
            {
                title: "پرینت",
                url: "/print",
                display: false,
                requireAuthentication: true,
                showMenu: false,
                componentResolver: <PrintProjects />,
            },
            {
                title: "جزییات پروژه",
                url: "/project/:id",
                display: false,
                requireAuthentication: true,
                showMenu: true,
                componentResolver: <Projects />,
            },
            {
                title: "جزییات پروژه",
                url: "/p/:id",
                display: false,
                requireAuthentication: true,
                showMenu: true,
                componentResolver: <Projects />,
            },
        ],
    },
    {
        title: "پیامک",
        url: "/sms",
        icon: "sms",
        display: true,
        showMenu: true,
        requireAuthentication: true,
        displayMode: {
            userMenu: [],
            appBar: ["md", "lg", "xl"],
            drawer: ["xs", "sm"],
        },
        children: [
            {
                title: "ارسال کمپین",
                url: "/create",
                icon: "rate_review",
                display: true,
                showMenu: true,
                requireAuthentication: true,
                displayMode: {
                    userMenu: [],
                    appBar: ["md", "lg", "xl"],
                    drawer: ["xs", "sm"],
                },
                componentResolver: <CreateSmsCampaign />,
            },
            {
                title: "لیست کمپین ها",
                url: "/sms-list",
                icon: "forum",
                display: true,
                showMenu: true,
                requireAuthentication: true,
                displayMode: {
                    userMenu: [],
                    appBar: ["md", "lg", "xl"],
                    drawer: ["xs", "sm"],
                },
                componentResolver: <SmsCampaignList />,
            },
            {
                title: "فروشگاه",
                url: "/store",
                icon: "shopping_bag",
                display: true,
                showMenu: true,
                requireAuthentication: true,
                displayMode: {
                    userMenu: [],
                    appBar: ["md", "lg", "xl"],
                    drawer: ["xs", "sm"],
                },
                componentResolver: <Store />,
            },
            {
                title: "تاریخچه خرید",
                url: "/store/history",
                icon: "receipt_long",
                display: true,
                showMenu: true,
                requireAuthentication: true,
                displayMode: {
                    userMenu: [],
                    appBar: ["md", "lg", "xl"],
                    drawer: ["xs", "sm"],
                },
                componentResolver: <PurchaseHistory />,
            },
        ],
    },
    {
        title: "فرایند های فروش",
        url: "/today",
        icon: "list_alt",
        display: true,
        showMenu: true,
        requireAuthentication: true,
        displayMode: {
            userMenu: [],
            appBar: ["md", "lg", "xl"],
            drawer: ["xs", "sm"],
        },
        componentResolver: <Today />,
        badgeCountResolver: async () => {
            const result = await SaleService.getBadgeCount("1");
            return (result.reminderCount ?? 0) + (result.taskCount ?? 0);
        },
    },
    // {
    //     title: "کارتن پلاست",
    //     url: "/ads",
    //     icon: "fluorescent",
    //     display: true,
    //     showMenu: true,
    //     requireAuthentication: true,
    //     displayMode: {
    //         userMenu: [],
    //         appBar: ["md", "lg", "xl"],
    //         drawer: ["xs", "sm"],
    //     },
    //     componentResolver: <ListAds />,
    // },
    {
        title: "جزییات کارتن پلاست",
        url: "/ad/:id",
        display: false,
        requireAuthentication: true,
        showMenu: true,
        componentResolver: <AdDetailPage />,
    },
    {
        title: "گزارشات",
        url: "/report",
        icon: "assessment",
        display: true,
        showMenu: true,
        requireAuthentication: true,
        displayMode: {
            userMenu: [],
            appBar: ["md", "lg", "xl"],
            drawer: ["xs", "sm"],
        },
        componentResolver: <Report />,
    },
    {
        title: "آموزش",
        url: "/learn",
        icon: "school",
        display: true,
        showMenu: true,
        requireAuthentication: true,
        displayMode: {
            userMenu: [],
            appBar: ["md", "lg", "xl"],
            drawer: ["xs", "sm"],
        },
        children: [
            {
                title: "دوره های آموزشی",
                url: "/courses",
                icon: "school",
                display: true,
                showMenu: true,
                requireAuthentication: true,
                displayMode: {
                    userMenu: [],
                    appBar: ["md", "lg", "xl"],
                    drawer: ["xs", "sm"],
                },
                componentResolver: <ListCourses />,
            },
            {
                title: "ویدئوهای آموزشی",
                url: "/tutorials",
                icon: "help",
                display: true,
                showMenu: true,
                requireAuthentication: true,
                displayMode: {
                    userMenu: [],
                    appBar: ["md", "lg", "xl"],
                    drawer: ["xs", "sm"],
                },
                componentResolver: <ListTutorials />,
            },
            {
                title: "تاریخچه دوره ها",
                url: "/course/history",
                icon: "history",
                display: true,
                showMenu: true,
                requireAuthentication: true,
                displayMode: {
                    userMenu: [],
                    appBar: ["md", "lg", "xl"],
                    drawer: ["xs", "sm"],
                },
                componentResolver: <CourseAttendanceHistory />,
            },
        ],
    },
    // {
    //     title: "محصولات",
    //     url: "/catalog",
    //     icon: "ballot",
    //     showMenu: true,
    //     display: true,
    //     requireAuthentication: true,
    //     displayMode: {
    //         userMenu: [],
    //         appBar: ["md", "lg", "xl"],
    //         drawer: ["xs", "sm"],
    //     },
    //     badgeCountResolver: () => {
    //         return new Promise((p) => {
    //             return p("جدید");
    //         });
    //     },
    //     componentResolver: <Catalog />,
    // },
    {
        title: "پروفایل",
        url: "/profile",
        icon: "person",
        display: true,
        showMenu: true,
        requireAuthentication: true,
        displayMode: {
            userMenu: ["xs", "sm", "md", "lg", "xl"],
            appBar: [],
            drawer: [],
        },
        componentResolver: <Profile />,
    },
    {
        title: "باشگاه مشتریان",
        url: "/scores",
        icon: "star",
        display: true,
        showMenu: true,
        requireAuthentication: true,
        displayMode: {
            userMenu: ["xs", "sm", "md", "lg", "xl"],
            appBar: [],
            drawer: [],
        },
        componentResolver: <ScorePage />,
    },
    {
        title: "مدیریت کاربران",
        url: "/users",
        icon: "group",
        display: true,
        showMenu: true,
        requireAuthentication: true,
        displayMode: {
            userMenu: ["xs", "sm", "md", "lg", "xl"],
            appBar: [],
            drawer: [],
        },
        componentResolver: <ListUsers />,
    },
    {
        title: "مشخصات",
        url: "/account-data",
        icon: "folder_open",
        display: true,
        showMenu: true,
        requireAuthentication: true,
        displayMode: {
            userMenu: ["xs", "sm", "md", "lg", "xl"],
            appBar: [],
            drawer: [],
        },
        componentResolver: <AccountData />,
    },
    {
        title: "پیشنهادات",
        url: "/forum",
        icon: "forum",
        display: true,
        showMenu: true,
        requireAuthentication: true,
        displayMode: {
            userMenu: ["xs", "sm", "md", "lg", "xl"],
            appBar: [],
            drawer: [],
        },
        componentResolver: <Ideas />,
    },
    {
        title: "نظرسنجی",
        url: "/polls",
        icon: "how_to_vote",
        display: true,
        showMenu: true,
        requireAuthentication: true,
        displayMode: {
            userMenu: ["xs", "sm", "md", "lg", "xl"],
            appBar: [],
            drawer: [],
        },
        componentResolver: <ListPolls />,
    },
    {
        title: "جزییات نظرسنجی",
        url: "/poll/:id",
        display: false,
        requireAuthentication: true,
        showMenu: true,
        componentResolver: <PollDetail />,
    },
    {
        title: "نظرسنجی کاربر",
        url: "/survey/:id",
        display: false,
        requireAuthentication: false,
        showMenu: false,
        componentResolver: <Survey />,
    },
    {
        title: "جزییات نظر سنجی",
        url: "/poll/anonymous/:id",
        display: false,
        requireAuthentication: false,
        showMenu: false,
        componentResolver: <PollDetail />,
    },
    {
        title: "کد ورود به جلسه",
        url: "/course/qr-code/:id",
        display: false,
        requireAuthentication: false,
        showMenu: false,
        componentResolver: <CourseQRCode />,
    },
    {
        title: "ویرایش کاربران",
        url: "/user/update/:id",
        display: false,
        requireAuthentication: true,
        showMenu: true,
        componentResolver: <UpdateUser />,
    },
    {
        title: "حذف کاربر",
        url: "/user/delete/:id",
        display: false,
        requireAuthentication: true,
        showMenu: true,
        componentResolver: <DeleteUser />,
    },
    {
        title: "تخصیص رمز عبور",
        url: "/assign/password",
        display: false,
        requireAuthentication: true,
        showMenu: true,
        componentResolver: <AssignPassword />,
    },
    {
        title: "ایجاد کاربر",
        url: "/user/create",
        display: false,
        requireAuthentication: true,
        showMenu: true,
        componentResolver: <CreateUser />,
    },
    // authentication
    {
        title: "ورود به عنوان شخص",
        url: "/impersonate",
        display: false,
        requireAuthentication: false,
        showMenu: false,
        componentResolver: <Impersonate />,
    },
    {
        title: "تکمیل ورود",
        url: "/auth-callback",
        display: false,
        requireAuthentication: false,
        showMenu: false,
        componentResolver: <Callback />,
    },
    {
        title: "خروج",
        url: "/logout",
        display: false,
        requireAuthentication: false,
        showMenu: false,
        componentResolver: <Login />,
    },
    {
        title: "ورود",
        url: "/login",
        display: false,
        requireAuthentication: false,
        showMenu: false,
        componentResolver: <Login />,
    },
    {
        title: "ثبت نام",
        url: "/register",
        display: false,
        requireAuthentication: false,
        showMenu: false,
        componentResolver: <SubmitRegistration />,
    },
    {
        title: "chat",
        url: "/chat",
        display: false,
        requireAuthentication: true,
        showMenu: false,
        componentResolver: <Chat />,
    },
    {
        title: "subscriptions",
        url: "/subscriptions",
        display: false,
        requireAuthentication: true,
        showMenu: true,
        componentResolver: <Subscriptions />,
    },
    {
        title: "account-invoice-information",
        url: "/account-data",
        display: false,
        requireAuthentication: true,
        showMenu: true,
        componentResolver: <AccountData />,
    },
    {
        url: "/*",
        display: false,
        requireAuthentication: false,
        showMenu: false,
        title: "NOT FOUND",
        componentResolver: <NotFoundPage />,
    },
];
